import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=ad50b30c&scoped=true"
import script from "./StudentDetail.vue?vue&type=script&lang=js"
export * from "./StudentDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=ad50b30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad50b30c",
  null
  
)

export default component.exports